import { CarouselProps } from '@design-system/carousel';
import { ImageProps } from '@design-system/image';
import { ExtendableElement } from '@design-system/types';

import { BodyRenderExternalData } from '~/components/BodyRender/models';
import { PIMAssetsCarouselBlockProps } from '~/components/PIMAssetsCarousel/models';
import { carouselMapper } from '~/mappers/carousel';
import { imageMapper } from '~/mappers/image';
import { pageBlockUIMapper } from '~/mappers/pageBlock';
import { SalsifyAssets } from '~/types/common';

import { PIMAssetsCarousel } from './models';

const moveImageToBeginning = (
  images: SalsifyAssets[],
  imageId: string
): SalsifyAssets[] => {
  if (!imageId) {
    return images;
  }

  return images.slice().sort(({ salsifyID: idA }, { salsifyID: idB }) => {
    if (idA === imageId) return -1;
    if (idB === imageId) return 1;

    return 0;
  });
};

const imageElementsMapper = (images: SalsifyAssets[]) =>
  images.map((image, index) => ({
    key: image.salsifyID,
    image: imageMapper(
      {
        image: {
          gatsbyImageData: image.localAsset.childImageSharp?.gatsbyImageData,
          url: image.salsifyUrl,
        },
        alt: image.altText,
        objectFit: 'contain',
      },
      index === 0
    ) as ExtendableElement<ImageProps>,
  }));

export const pimAssetsCarouselMapper = (
  {
    pageBlockUI: [pageBlockUI],
    componentId,
    carouselUI: [carouselUI],
  }: PIMAssetsCarousel,
  _currentPageUid: string,
  { salsifyExternalData }: BodyRenderExternalData
) => {
  const { salsifyDigitalAssets, heroImageID } = salsifyExternalData || {
    heroImageID: '',
  };

  if (!salsifyDigitalAssets) return null;

  const images = imageElementsMapper(
    moveImageToBeginning(salsifyDigitalAssets, heroImageID)
  );

  const carousel: PIMAssetsCarouselBlockProps = {
    ...carouselMapper<Omit<CarouselProps, 'items'>>(carouselUI),
    images,
  };

  return {
    pageBlockUI: pageBlockUIMapper(pageBlockUI.ui),
    componentId,
    carousel,
  };
};
